import styled, { css } from 'styled-components';
import { media } from '../../media';

const applyGutter = (media) => {
  let gutter;
  switch (media) {
    case 'tablet':
      gutter = 16;
      break;
    default:
      gutter = 24;
  }
  return css`
    margin: -${gutter}px 0 ${gutter}px -${gutter}px;
    & > * {
      padding: ${gutter}px 0 0 ${gutter}px;
    }
  `;
}

const applyAlign = ({align}) => {
  if (align) {
    let alignProp;
    switch (align) {
      case 'start':
        alignProp = 'flex-start';
        break;
      case 'end':
        alignProp = 'flex-end';
        break;
      default:
        alignProp = 'center';
    }
    return css`
      align-items: ${alignProp};
    `;
  }
};

const applyJustify = ({justify}) => {
  if (justify) {
    let justifyProp;
    switch (justify) {
      case 'start':
        justifyProp = 'flex-start';
        break;
      case 'end':
        justifyProp = 'flex-end';
        break;
       case 'space-between':
        justifyProp = 'space-between';
        break;
      default:
        justifyProp = 'center';
    }
    return css`
      justify-content: ${justifyProp};
    `;
  }
};

const Flex = styled.div`
  display: flex;
  ${applyAlign};
  ${applyJustify};

   
  ${({width}) => width && css`
    width: ${width * 100}%;
  `};


  ${props => props.column && css`
    flex-direction: column;
    ` };  

  ${props => props.wrap && css`
    flex-wrap: wrap;
    ` };

  ${({gutter}) => {
    if (gutter !== false) {
      return css`
        ${applyGutter};
        ${media.tablet`
          ${applyGutter('tablet')};
        `};
        ${media.tabletSmall`
          margin: 0;
          & > * {
            padding: 0;
          }
        `};
      `;
    }
  }};

  ${props => props.column && css`
    margin-bottom:0;
  ` };  

  ${media.tabletSmall`
    display: block;
  `};

  @media print {
    display: flex;
    flex-direction: column;
  }
`;

export default Flex;



// WEBPACK FOOTER //
// ./src/core/layout/components/Flex/Flex.js